export default __webpack_public_path__ + "static/media/postSneakPeekImg.d6a56b73.svg";